/*
 * @Author: liuzhezhe
 * @Date: 2022-10-25 11:09:30
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-02-28 18:22:08
 * @FilePath: \gerlun-react-website\src\pages\information\inform-particulars\index.jsx
 * @Description:
 */
// import React, { useState, useEffect, setState, componentDidMount } from 'react'
import React, { useState, useEffect } from 'react'
import styles from './inform-particulars.scss'
import User from '@/modules/user'
// import { useParams } from 'react-router-dom'
import { VerticalAlignBottomOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'

const ListParticulars = (props) => {
  const params = useParams()
  const id = params.id
  const [data, setData] = useState({})
  const [accessoryList, setAccessory] = useState([])
  const user = new User()
  // const params = useParams()
  const cutParticulars = (id) => {
    user.getArticleID(id)
      .then(res => {
        setData(res)
        setAccessory(res.resAttachDtoList)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  useEffect(() => {
    console.log(props, props, props, 'props')
    console.log(id, 'search')
    cutParticulars(id)
  }, [])
  const download = (item) => {
    // const docId = id
    // const attachName = item.name
    // user.downloadAttach(docId, attachName)
  }
  return <section className={styles['information']}>
    <div className={styles['particulars']}>
      <div className={styles['particulars-title']}>{data.articleName}</div>
      <div className={styles['sub-title']}>
        <ClockCircleOutlined style={{ 'margin-right': '5px' }}/>
        <span>{data.docDate || data.operationTime || ''}</span>
        <span style={{ 'margin-left': '15px' }}>作者：{data.author || data.articleSource || ''}</span>
      </div>
      <div className={styles['particulars-content']} dangerouslySetInnerHTML = {{ __html: data.docContext }}></div>
      <div className={styles['accessory']}>
        { accessoryList ? accessoryList.map((val, index) => {
          return <div key={index} href='/#' className={styles['accessory-color']} onClick={(e) => e.preventDefault()}><a key={index}>{val.name}</a><a href='/#'><VerticalAlignBottomOutlined onClick={(e) => e.preventDefault() || download(val) } style={{ fontSize: '16px' }} /></a></div>
        }) : null}
      </div>
    </div>
  </section>
}

export default ListParticulars
